var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rc-rich-box-design"},[_c('label',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.initComponent.name))]),_vm._v(" "),_c('div',{ref:"editorDesign",staticClass:"editor-design"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d2afb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/components/rich-box/rc-rich-box.vue
// module id = null
// module chunks = 